export enum DigitGroup {
    Ones,
    Teens,
    Tens,
    Hundreds,
    Thousands
}